import React, { FC } from 'react';
import Modal from '@common/modal';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './verification.module.scss';
const cx = classnames.bind(styles);

/**
 * 본인인증 동의 모달
 */

interface IVerificationModalProps {
  visible: boolean;
  onClose: () => void;
}

const VerificationModal: FC<IVerificationModalProps> = ({ visible, onClose }) => {
  const handleSMS = () => {
    V2Route.openKcbSmsPage();
    onClose();
  };

  const handleIPIN = () => {
    V2Route.openKcbIpinPage();
    onClose();
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layerVerification')}>
        <strong className={cx('title')}>본인 인증 방식을 선택해주세요.</strong>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'phone')} type={'button'} onClick={handleSMS}>
            휴대폰 본인인증
          </button>
          <button className={cx('btn', 'iPin')} type={'button'} onClick={handleIPIN}>
            아이핀 본인인증
          </button>
        </div>
        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default VerificationModal;
